module.exports = __webpack_public_path__ + "static/media/bg_animation.f762bc5d.png";